import { formPathname } from '../components/CardFormPublic/constants';

const getSubRouteFromInternalResources = <RouteName extends string = string>(
  routeName: RouteName,
): `${typeof internalResourcesRoute}/${RouteName}` => `${internalResourcesRoute}/${routeName}` as const;
const getSubRouteFromPublicResources = <RouteName extends string = string>(
  routeName: RouteName,
): `${typeof publicResourcesRoute}${RouteName}` => `${publicResourcesRoute}${routeName}` as const;

const internalResourcesRoute = '/resources';
export const internalRoutes = {
  resources: internalResourcesRoute,
  scriptsVendors: getSubRouteFromInternalResources('vendors-scripts'),
  styles: getSubRouteFromInternalResources('styles'),
  fonts: getSubRouteFromInternalResources('fonts'),
  cardNetworks: getSubRouteFromInternalResources('cardNetworks'),
  appCssBundle: getSubRouteFromInternalResources('app'),
  appJsBundle: getSubRouteFromInternalResources('app.bundle'), // rely on webpack configuration. Dist folder contain app.bundle.min.js file with "// # sourceMappingURL=app.bundle.min.js.map" which we need handle by api."
} as const;

export const publicRootRoute = `/${formPathname}` as const; // rely on mapping in FryingPan - https://fryingpan.wixpress.com/services/com.wixpress.payments-cc-form
const publicResourcesRoute = `${publicRootRoute}${internalResourcesRoute}/` as const; // end with "/" for being the same format as hadron
export const publicRoutes = {
  resources: publicResourcesRoute,
  cardNetworks: getSubRouteFromPublicResources('cardNetworks'),
} as const;
